export enum EstadoAvisoObraEnum {
    BORRADOR = 1,
    RECIBIDO = 2,
    EN_REVISION = 3,
    PENDIENTE_VISITA = 4,
    PRESENTADO = 5,
    FINALIZADO = 6,
    CANCELADO = 7,
    SUSPENDIDO = 8,
    EN_EXTENSION = 9,
    A_REVISAR = 10
}

export const getEstadoAvisoObraLabel = (estado: EstadoAvisoObraEnum | number): string => {
    switch (estado) {
        case EstadoAvisoObraEnum.EN_REVISION:
            return 'En Revisión';
        case EstadoAvisoObraEnum.PENDIENTE_VISITA:
            return 'Pendiente Visita';
        case EstadoAvisoObraEnum.PRESENTADO:
            return 'Presentado';
        case EstadoAvisoObraEnum.RECIBIDO:
            return 'Recibido';
        case EstadoAvisoObraEnum.BORRADOR:
            return 'Borrador';
        case EstadoAvisoObraEnum.CANCELADO:
            return 'Cancelado';
        case EstadoAvisoObraEnum.FINALIZADO:
            return 'Finalizado';
        case EstadoAvisoObraEnum.SUSPENDIDO:
            return 'Suspendido';
        case EstadoAvisoObraEnum.EN_EXTENSION:
            return 'En Extensión';
        case EstadoAvisoObraEnum.A_REVISAR:
            return 'A Revisar';
        default:
            return 'Desconocido';
    }
};
